import $ from 'jquery';
import EventsHelper from '../../../_helpers/events';

export default class CourtGraphic {

  $CourtGraphic = {};
  $setDropdown = null;
  $tabsBtns = null;
  data = {};
  setNo = 0;

  matchStatus = {
    DEFAULT: -1,
    SCHEDULED: 0,
    LIVE: 1,
    FINISHED: 2,
  };


  constructor() {

    let _this = this;

    _this.init();

    EventsHelper.OnAjaxModuleLoaded(function () {
      _this.init();
    });

    EventsHelper.On('MatchDataUpdate', function (data) {

      if (data.detail) {
        _this.data = data.detail;
        _this.update();
      }

    });

    EventsHelper.On('TabChanged', function (tabid) {
      if (tabid.detail === 'players') {
        _this.init();
      }
    });

  }

  init() {
    let _this = this;

    _this.$CourtGraphic = $('.vbw-sets-lineup-updater');
    _this.libraryUrl = window.matchconfig?.libraries?.courtgraphic ?? null;

    _this.$setDropdown = _this.$CourtGraphic.find('.tab-type-dropdown');
    _this.$tabsBtns = _this.$setDropdown.find('.tab-item');

    _this.$setDropdown.off('click').click(function (e) {
      let element = e.currentTarget;
      element.classList.toggle('open');
      e.stopPropagation();
    });

    $(document).click(function () {
      _this.$setDropdown.removeClass('open');
    });

    _this.$tabsBtns.click(function (e) {
      let tabId = $(this).data('tab-id');
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      _this.showSetContent(tabId);
    });



    EventsHelper.Trigger('DropDownReload');
  }


  showSetContent(tabId) {

    if (!tabId) { return; }

    let $selectedContent = $('[data-tab="' + tabId + '"]');
    if ($selectedContent.length) {
      $selectedContent.siblings('[data-tab]').hide();
      $selectedContent.show();
      EventsHelper.Trigger("TabChanged", tabId);
    }

  }

  update() {
    let _this = this;

    if (_this.data.currentSetNo !== _this.setNo) {
      _this.loadContent();
      _this.checkUpdate();
    }

  }

  loadContent() {
    let _this = this;
    if (_this.libraryUrl) {
      _this.$CourtGraphic.load(_this.libraryUrl, function () {
        
        if (_this.data.currentSetNo !== 1) {
          _this.$CourtGraphic.find('.tab-type-dropdown').addClass('multiple');
        } else {
          _this.$CourtGraphic.find('.tab-type-dropdown').removeClass('multiple');
        }

        _this.init();

      });
    }
  }

  checkUpdate() {
    let _this = this;
    let moduleSetNo = $('.vbw-sets-lineup-wrapper').data('current-set');

    if (_this.data.status !== _this.matchStatus.LIVE) { return; }

    if (moduleSetNo !== _this.data.currentSetNo) {

      setTimeout(function () {
        _this.loadContent();
        _this.checkUpdate();
      }, 10000);

    } else {
      _this.setNo = _this.data.currentSetNo;
      _this.init();
    }

  }
}

